import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowContained = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 33,
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 32,
			height: 32,
			rx: 16,
			fill: "#0A0A0A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8335 12.3333L20.1668 20.6666",
			stroke: "#FAFAFA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1668 12.3333V20.6666H11.8335",
			stroke: "#FAFAFA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgArrowContained;
